import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';

export interface ModalButton {
  label: string;
  action: () => void;
  type?: 'primary' | 'outline' | 'danger';
  closeOnClick?: boolean;
  isActive?: boolean;
}

export interface ModalConfig {
  title?: string;
  message?: string;
  image?: string;
  showCloseButton?: boolean;
  buttons?: ModalButton[];
  customClass?: string;
  data?: any;
}

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  constructor(private router: Router) {}
  private modalState = new BehaviorSubject<{
    isOpen: boolean;
    config: ModalConfig | null;
  }>({
    isOpen: false,
    config: null,
  });

  get modalState$(): Observable<{
    isOpen: boolean;
    config: ModalConfig | null;
  }> {
    return this.modalState.asObservable();
  }

  open(config: ModalConfig) {
    this.modalState.next({ isOpen: true, config });
  }

  close() {
    this.modalState.next({ isOpen: false, config: null });
  }

  showPopup(data: any) {
    this.open({
      title: data.title,
      message: data.message,
      image: data.image,
      buttons: [
        {
          label: data.buttonText,
          type: 'primary',
          action: () => {
            this.router.navigate([data.path]);
          },
        },
        // {
        //   label: data.buttonText2,
        //     type: 'outline',

        //   action: () => {
        //     this.close();
        //   },
        // },
      ],
    });
  }
}
